export class UploadedFile {

  constructor(
    public file: File,
    public response: any
  ) { }

}
